import { BasicSizingFlowState } from 'utils/is-basic-sizing-flow-types';
import { isBasicSizingSystemPreference } from 'utils/project';

export function isBasicSizingFlowState(state: BasicSizingFlowState): boolean {
  return (
    isBasicSizingSystemPreference(state.systemPreference) &&
    state.sizingPreference !== 'Detailed Estimate'
  );
}
